/**
 * This file contains the configuration of all app sections.
   The sections rendered and displayed to the user depend on the permissions taken from the api/grants call.
 */

/** Define explorer buttons */
export const explorers = [""];

/** Map buttons with modal components*/
export const modals = new Map([
  ["Import Masterfile IMPORT_MASTER", { component: "ImportMaster" }],
  ["Import Portfolio IMPORT_PORTFOLIO", { component: "ImportPortfolio" }],
  [
    "Internal List with HZ-File (extern) RECON_EXT",
    { component: "ReconciliationExt" },
  ],
  [
    "Internal List with Host-File (intern) RECON_INT",
    { component: "ReconciliationInt" },
  ],
  [
    "Internal List with HZ-File (extern) STAT_EXT",
    { component: "StatisticsExt" },
  ],
  [
    "Internal List with Host-File (intern) STAT_INT",
    { component: "StatisticsInt" },
  ],
]);

/** Map buttons to routes */
export const rootPages = new Map([
  [
    "Client data export",
    {
      route: "/client-export",
    },
  ],
]);

export const config = { explorers, modals, rootPages };
